import React from 'react';
import { useLocale } from '@/common/hooks/index';
import { formatDisplayDate } from '@/common/utils/index';

const DateOfDeathCell = ({ value }) => {
  const { isFr } = useLocale();
  const formattedValue = formatDisplayDate(value, isFr ? 'fr' : 'en');

  return <span>{formattedValue || '-'}</span>;
};

export const renderDateOfDeathCell = ({ value }) => (
  <DateOfDeathCell value={value} />
);
